import { parse } from 'createjs-collection';
import * as fJS from './fJS';
export class jsColor {
  _r;
  _g;
  _b;
  _a;

  constructor(obj) {
    this._a = 1;
    if (typeof obj == 'undefined' || obj == null) return;
    if (Array.isArray(obj)) {
      this.r = parseInt(obj[0]);
      this.g = parseInt(obj[1]);
      this.b = parseInt(obj[2]);
      if (fJS.isNumeric(obj[3])) {
        this.a == obj[3];
      }
      return;
    }
    if (this.setRGBFromString(obj) === true) return;
    if (this.setRGBAFromString(obj) === true) return;
    if (this.setRGBfromHex(obj) === true) return;
    if (this.setRGBAfromHexA(obj) === true) return;
    if (this.setRGBfromName(obj) === true) return;
    if (typeof obj == 'object' && obj != null) {
      this.r = obj.r;
      this.g = obj.g;
      this.b = obj.b;
      if (fJS.isNumeric(obj.a)) {
        this.a = obj.a;
      }
    }
  }

  setRGBFromString(rgb) {
    let ex =
      /^rgb\((((((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5]),\s?)){2}|((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5])\s)){2})((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5]))|((((([1-9]?\d(\.\d+)?)|100|(\.\d+))%,\s?){2}|((([1-9]?\d(\.\d+)?)|100|(\.\d+))%\s){2})(([1-9]?\d(\.\d+)?)|100|(\.\d+))%))\)$/i;
    if (ex.test(rgb)) {
      let sep = rgb.indexOf(',') > -1 ? ',' : ' ';
      rgb = rgb.substr(4).split(')')[0].split(sep);

      for (let R in rgb) {
        let r = rgb[R];
        if (typeof r != 'string') continue;
        if (r.indexOf('%') > -1) rgb[R] = Math.round((r.substr(0, r.length - 1) / 100) * 255);
      }

      this.r = parseInt(rgb[0]);
      this.g = parseInt(rgb[1]);
      this.b = parseInt(rgb[2]);
      return true;
    } else {
      return false;
    }
  }

  setRGBAFromString(rgba) {
    let ex =
      /^rgba\((((((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5]),\s?)){3})|(((([1-9]?\d(\.\d+)?)|100|(\.\d+))%,\s?){3}))|(((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5])\s){3})|(((([1-9]?\d(\.\d+)?)|100|(\.\d+))%\s){3}))\/\s)((0?\.\d+)|[01]|(([1-9]?\d(\.\d+)?)|100|(\.\d+))%)\)$/i;
    if (ex.test(rgba)) {
      let sep = rgba.indexOf(',') > -1 ? ',' : ' ';
      rgba = rgba.substr(5).split(')')[0].split(sep);

      if (rgba.indexOf('/') > -1) rgba.splice(3, 1);

      for (let R in rgba) {
        let r = rgba[R];
        if (typeof r != 'string') continue;
        if (r.indexOf('%') > -1) {
          let p = r.substr(0, r.length - 1) / 100;

          if (R < 3) {
            rgba[R] = Math.round(p * 255);
          } else {
            rgba[R] = p;
          }
        }
      }

      this.r = parseInt(rgba[0]);
      this.g = parseInt(rgba[1]);
      this.b = parseInt(rgba[2]);
      this.a = Math.round(+rgba[3] * 255);
      return true;
    } else {
      return false;
    }
  }

  setRGBfromHex(h, isPct) {
    let ex = /^#([\da-f]{3}){1,2}$/i;
    if (ex.test(h)) {
      let r = 0,
        g = 0,
        b = 0;
      isPct = isPct === true;

      // 3 digits
      if (h.length == 4) {
        r = '0x' + h[1] + h[1];
        g = '0x' + h[2] + h[2];
        b = '0x' + h[3] + h[3];

        // 6 digits
      } else if (h.length == 7) {
        r = '0x' + h[1] + h[2];
        g = '0x' + h[3] + h[4];
        b = '0x' + h[5] + h[6];
      }
      if (isPct) {
        r = +((r / 255) * 100).toFixed(1);
        g = +((g / 255) * 100).toFixed(1);
        b = +((b / 255) * 100).toFixed(1);
      }
      this.r = r;
      this.g = g;
      this.b = b;
      return true;
    } else {
      return false;
    }
  }

  setRGBAfromHexA(h, isPct) {
    let ex = /^#([\da-f]{4}){1,2}$/i;
    if (ex.test(h)) {
      let r = 0,
        g = 0,
        b = 0,
        a = 1;
      isPct = isPct === true;

      if (h.length == 5) {
        r = '0x' + h[1] + h[1];
        g = '0x' + h[2] + h[2];
        b = '0x' + h[3] + h[3];
        a = '0x' + h[4] + h[4];
      } else if (h.length == 9) {
        r = '0x' + h[1] + h[2];
        g = '0x' + h[3] + h[4];
        b = '0x' + h[5] + h[6];
        a = '0x' + h[7] + h[8];
      }
      a = +(a / 255).toFixed(3);
      if (isPct) {
        r = +((r / 255) * 100).toFixed(1);
        g = +((g / 255) * 100).toFixed(1);
        b = +((b / 255) * 100).toFixed(1);
        a = +(a * 100).toFixed(1);
      }

      this.r = r;
      this.g = g;
      this.b = b;
      this.a = a;
      return true;
    } else {
      return false;
    }
  }

  setRGBfromName(name) {
    // get RGB from named color in div
    let fakeDiv = document.createElement('div');
    fakeDiv.style.color = name;
    document.body.appendChild(fakeDiv);

    let cs = window.getComputedStyle(fakeDiv),
      pv = cs.getPropertyValue('color');

    document.body.removeChild(fakeDiv);

    // code ripped from RGBToHex() (except pv is substringed)
    let rgb = pv.substr(4).split(')')[0].split(',');

    this.r = parseInt(rgb[0]);
    this.g = parseInt(rgb[1]);
    this.b = parseInt(rgb[2]);
    return true;
  }

  RGBToHex() {
    let r = (+this.r).toString(16),
      g = (+this.g).toString(16),
      b = (+this.b).toString(16);

    if (r.length == 1) r = '0' + r;
    if (g.length == 1) g = '0' + g;
    if (b.length == 1) b = '0' + b;
    return '#' + r + g + b;
  }

  RGBAToHexA() {
    let r = (+this.r).toString(16),
      g = (+this.g).toString(16),
      b = (+this.b).toString(16),
      a = (+this.a).toString(16);

    if (r.length == 1) r = '0' + r;
    if (g.length == 1) g = '0' + g;
    if (b.length == 1) b = '0' + b;
    if (a.length == 1) a = '0' + a;
    return '#' + r + g + b + a;
  }

  RGBToString(isPct) {
    isPct = isPct === true;
    return (
      'rgb(' + (isPct ? this.r + '%,' + this.g + '%,' + this.b + '%' : +this.r + ',' + +this.g + ',' + +this.b) + ')'
    );
  }

  RGBAToString(isPct) {
    isPct = isPct === true;
    return (
      'rgba(' +
      (isPct
        ? this.r + '%,' + this.g + '%,' + this.b + '%' + ',' + this.a
        : +this.r + ',' + +this.g + ',' + +this.b + ',' + this.a) +
      ')'
    );
  }

  RGBToHSL() {
    let rgb = this.RGBToString();

    let sep = rgb.indexOf(',') > -1 ? ',' : ' ';
    rgb = rgb.substr(4).split(')')[0].split(sep);

    // convert %s to 0–255
    for (let R in rgb) {
      let r = rgb[R];
      if (typeof r != 'string') continue;
      if (r.indexOf('%') > -1) rgb[R] = Math.round((r.substr(0, r.length - 1) / 100) * 255);
    }

    // make r, g, and b fractions of 1
    let r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      // find greatest and smallest channel values
      cmin = Math.min(r, g, b),
      cmax = Math.max(r, g, b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;

    // calculate hue
    // no difference
    if (delta == 0) h = 0;
    // red is max
    else if (cmax == r) h = ((g - b) / delta) % 6;
    // green is max
    else if (cmax == g) h = (b - r) / delta + 2;
    // blue is max
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    // make negative hues positive behind 360°
    if (h < 0) h += 360;

    // calculate lightness
    l = (cmax + cmin) / 2;

    // calculate saturation
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

    // multiply l and s by 100
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return 'hsl(' + h + ',' + s + '%,' + l + '%)';
  }

  RGBAToHSLA() {
    let rgba = this.RGBAToString();
    let sep = rgba.indexOf(',') > -1 ? ',' : ' ';
    rgba = rgba.substr(5).split(')')[0].split(sep);

    // strip the slash if using space-separated syntax
    if (rgba.indexOf('/') > -1) rgba.splice(3, 1);

    for (let R in rgba) {
      let r = rgba[R];
      if (typeof r != 'string') continue;
      if (r.indexOf('%') > -1) {
        let p = r.substr(0, r.length - 1) / 100;

        if (R < 3) {
          rgba[R] = Math.round(p * 255);
        }
      }
    }

    // make r, g, and b fractions of 1
    let r = rgba[0] / 255,
      g = rgba[1] / 255,
      b = rgba[2] / 255,
      a = rgba[3],
      // find greatest and smallest channel values
      cmin = Math.min(r, g, b),
      cmax = Math.max(r, g, b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;

    // calculate hue
    // no difference
    if (delta == 0) h = 0;
    // red is max
    else if (cmax == r) h = ((g - b) / delta) % 6;
    // green is max
    else if (cmax == g) h = (b - r) / delta + 2;
    // blue is max
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    // make negative hues positive behind 360°
    if (h < 0) h += 360;

    // calculate lightness
    l = (cmax + cmin) / 2;

    // calculate saturation
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

    // multiply l and s by 100
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return 'hsla(' + h + ',' + s + '%,' + l + '%,' + a + ')';
  }

  isSimilar(c) {
    return this._hexColorDelta(c) > 0.9;
  }

  _hexColorDelta(c) {
    let r = 255 - Math.abs(this.r - c.r),
      g = 255 - Math.abs(this.g - c.g),
      b = 255 - Math.abs(this.b - c.b);
    // limit differences between 0 and 1
    r /= 255;
    g /= 255;
    b /= 255;

    // 0 means opposit colors, 1 means same colors
    return (r + g + b) / 3;
  }

  get r() {
    return this._r;
  }
  set r(v) {
    this._r = v;
  }
  get g() {
    return this._g;
  }
  set g(v) {
    this._g = v;
  }
  get b() {
    return this._b;
  }
  set b(v) {
    this._b = v;
  }
  get a() {
    return this._a;
  }
  set a(v) {
    this._a = v;
  }
}
